import styled from "styled-components";

export const InputWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
        
    label {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        color: #344054;
        flex: none;
        order: 0;
        flex-grow: 0;
        color: white;
    }

    input {

        box-sizing: border-box;

        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 10px 14px;
        gap: 8px;

        width: 100%;
        height: 44px;

        background: #FFFFFF;
        border: 1px solid #D0D5DD;

        box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
        border-radius: 8px;

        flex: none;
        order: 1;
        align-self: stretch;
        flex-grow: 0;

        &:disabled {
            opacity: 0.5;
        }
    }

`